import React from "react";
import { ThemeProvider } from "@aws-amplify/ui-react";

import "@aws-amplify/ui-react/styles.css";

import { LivenessDetector } from "./components/LivenessDetector";
import VivaDetector from "./components/viva/LivenessDetector";

import { Amplify } from "aws-amplify";
import awsexports from "./aws-exports";

Amplify.configure(awsexports);

export default function App() {
  const query = new URLSearchParams(window.location.search)
  const product = query.get('product')
  return (
    <ThemeProvider>
      {
        product === 'viva' ? <VivaDetector /> : <LivenessDetector />
      }
    </ThemeProvider>
  );
}
